var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99777 17.5C6.00377 17.5 5.48461 16.3497 6.08427 15.6065L6.17294 15.5085L13.1729 8.5085C13.3738 8.30763 13.6411 8.18696 13.9246 8.16913C14.2082 8.1513 14.4885 8.23754 14.7129 8.41167L14.8226 8.5085L21.8226 15.5085L21.9194 15.6182L21.9824 15.708L22.0454 15.82L22.0653 15.862L22.0968 15.9402L22.1341 16.0662L22.1458 16.128L22.1574 16.198L22.1621 16.2645L22.1621 16.4022L22.1563 16.4698L22.1458 16.5398L22.1341 16.6005L22.0968 16.7265L22.0653 16.8047L21.9836 16.9587L21.9078 17.0637L21.8226 17.1582L21.7129 17.255L21.6231 17.318L21.5111 17.381L21.4691 17.4008L21.3909 17.4323L21.2649 17.4697L21.2031 17.4813L21.1331 17.493L21.0666 17.4977L6.99777 17.5Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.7a32854feb1057838b27f4d0194c8649.svg";
export { ForwardRef as ReactComponent };